export enum Status {
    to_be_assigned = 'Da assegnare',
    accepted = 'Accettata',
    rejected = 'Rifiutata',
    pending = 'In attesa di conferma'
}

